import PropertyTenantReducer from "./tenant"

import { combineReducers } from "redux"
import WorkOrderReducer from "./work-order"

export default combineReducers({
    tenant: PropertyTenantReducer,
    workOrder: WorkOrderReducer
})